// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container__jdVhU","icon":"EmptyState_icon__pWIbh"};